import React, { createContext, useContext } from 'react';
import { usePersonStatus } from '~/pages/admin/map/hooks/usePersonStatus';
import type { IPersonStatus } from '~/utils/interface/map';

const JourneyPersonStatusContext = createContext<IPersonStatus[]>([]);

export function JourneyPersonStatusProvider({ children }: { children: React.ReactNode }) {
  const personStatuses = usePersonStatus();
  return (
    <JourneyPersonStatusContext.Provider value={personStatuses}>{children}</JourneyPersonStatusContext.Provider>
  );
}

export function useJourneyPersonStatuses(): IPersonStatus[] {
  return useContext(JourneyPersonStatusContext);
}
